import puzzleMonthDates from '../../data/puzzles'

export const getPuzzleMonthDates = () => puzzleMonthDates
